const API_HOST = typeof import.meta.env.API_HOST !== 'undefined' ? import.meta.env.API_HOST : '';

const AUTH_URL = `${API_HOST}${import.meta.env.AUTH}`;
const AUTHENTICATE_URL = `${API_HOST}${import.meta.env.AUTHENTICATE}`;
const CHANGE_LANGUAGE_URL = `${API_HOST}${import.meta.env.CHANGE_LANGUAGE}`;
const GET_PLAYER_HISTORY_URL = `${API_HOST}${import.meta.env.GET_PLAYER_HISTORY}`;
const GET_PLAYER_DAY_HISTORY_URL = `${API_HOST}${import.meta.env.GET_PLAYER_DAY_HISTORY}`;
const SET_FAVORITE_URL = `${API_HOST}${import.meta.env.SET_FAVORITE}`;
const GET_USER_URL = `${API_HOST}${import.meta.env.GET_USER}`;
const GET_LOCALE_URL = `${API_HOST}${import.meta.env.GET_LOCALE}`;
const CLEAR_AUTH_PARAMS = `${API_HOST}${import.meta.env.CLEAR_AUTH_PARAMS}`;
const OUTGOING_CALLS = `${API_HOST}${import.meta.env.OUTGOING_CALLS}`;

export {
  API_HOST,
  AUTH_URL,
  AUTHENTICATE_URL,
  CHANGE_LANGUAGE_URL,
  GET_PLAYER_HISTORY_URL,
  GET_PLAYER_DAY_HISTORY_URL,
  SET_FAVORITE_URL,
  GET_USER_URL,
  GET_LOCALE_URL,
  CLEAR_AUTH_PARAMS,
  OUTGOING_CALLS,
};
